module.exports = __webpack_public_path__ + "img/8.b6d871f7.jpg";